import { useMutation, gql } from '@apollo/client'

interface Variables {
  name: string
  email: string
  phoneNumber: string
}

const mutation = gql`
  mutation AddUserToPlatform($name: String!, $email: String!, $phoneNumber: String!) {
    addUserToPlatform(name: $name, email: $email, phoneNumber: $phoneNumber)
  }
`

const useAddUserToPlatform = () => {
  const [mutate] = useMutation<{ addUserToPlatform: boolean }, Variables>(mutation)

  return (variables: Variables) => mutate({ variables })
}

export default useAddUserToPlatform
